import { getChartValueColor } from '../../../../utils/chart';

const getOptions = ({ config, data, theme }) => {
  const fontColor = getChartValueColor(theme);

  return {
    tooltip: {
      backgroundColor: 'transparent',
      borderColor: 'transparent',
      extraCssText: 'box-shadow: none',
      ...config.tooltip,
    },
    series: [
      {
        type: 'treemap',
        animation: true,
        animationDuration: 1000,
        visibleMin: 300,
        width: '100%',
        height: '100%',
        left: 0,
        bottom: 0,
        top: 'auto',
        right: 'auto',
        roam: false,
        nodeClick: false,
        label: {
          show: true,
          color: fontColor,
          fontSize: 12,
          fontWeight: 'bold',
          ...config?.series?.label,
        },
        upperLabel: {
          show: false,
          ...config?.series?.upperLabel,
        },
        breadcrumb: {
          show: false,
        },
        itemStyle: {
          borderColor: null,
          borderWidth: 0,
          gapWidth: 5,
        },

        levels: config?.series?.levels ?? COMMON_LEVELS,
        data: data,
        sort: null,
        id: 'grouped-treemap',
        colorMappingBy: 'id',
      },
    ],
  };
};

export default getOptions;

const COMMON_LEVELS = [
  {
    itemStyle: {
      borderWidth: 0,
      gapWidth: 0,
    },
    upperLabel: {
      show: false,
    },
  },
];
